import { render } from "./participantModal.vue?vue&type=template&id=85245e60&ts=true"
import script from "./participantModal.vue?vue&type=script&lang=ts"
export * from "./participantModal.vue?vue&type=script&lang=ts"

import "./participantModal.vue?vue&type=style&index=0&id=85245e60&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__